
import React, { useState, useEffect } from 'react'
import { Field, Formik } from 'formik';
import { CreateCompany, GetAllCompanies, GetCompanyList, UpdateCompanyLogo } from '../../services/companyService';
import { GetGCPSignedUploadUrl } from '../../services/commonService';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2"
import Layout from '../../layout';
import toHtml from 'html-react-parser';
import Breadcrums from '../../components/common/breadcrumbs';
import $ from 'jquery';
import { countries } from 'countries-list';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSearchParams } from 'react-router-dom';
import ReactCountryFlag from 'react-country-flag';
import { SelectPicker } from 'rsuite';
import { FILE_SLUGS, MAX_FILE_SIZE, UPLOAD_DIRS } from '../../utils/Constants';
import { companyDetail, getMobileLength } from '../../helpers/commonFunctions';
import CustomCkeditor from '../../components/common/customeditor';

const CompanyForm = () => {

  const breadcrumbs = [
    {
      title: "Dashboard",
      url: "/admin/dashboard"
    },
    {
      title: "Companies",
      url: "/admin/company/list/1"
    },
    {
      title: "Add",
      url: ""
    },
  ]

  const [searchParams] = useSearchParams();
  const [showDefault, setShowDefault] = useState({});
  const navigate = useNavigate()
  const [previewImage, setPreviewImage] = useState("");
  const [submitted, setSubmitted] = useState(false)
  const [year, setYear] = useState([])
  const [selectedCountryCode, setSelectedCountryCode] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loader, setLoader] = useState('false')
  const { state } = useLocation();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [initialValues, setInitialValues] = useState();

  useEffect(() => {
    UpdateCompanyLogo({ id: 3, logo: "sample" })
      .then(res => console.log("UpdateCompanyLogo test ====>", res))
      .catch(err => console.log("UpdateCompanyLogo test error ====>", err?.response?.status, err?.response?.data, err));
  }, []);

  useEffect(() => {
    setInitialValues({
      logo: '',
      name: state && state.name ? state.name : "",
      short_description: state && state.short_description ? state.short_description : "",
      established_year: state && state.established_year ? state.established_year : "",
      official_address: state && state.official_address ? state.official_address : "",
      official_email: state && state.official_email ? state.official_email : "",
      long_description: state && state.long_description ? state.long_description : "",
      official_phone_number: state && state.official_phone_number ? state.official_phone_number : "",
      licence_number: state && state.licence_number ? state.licence_number : "",
      // tax_type : state && state.tax_type ? state.tax_type : "",
      subscription_access: state && state.subscription_access ? state.subscription_access : "",
      country_code: state && state.country_code ? (Array.isArray(state.country_code) ? state.country_code : [Number(state.country_code)]) : [Number(966)],
      is_grouped: ''
    });
    setDataLoaded(true);
  }, [])

  useEffect(() => {
    const options = Object.keys(countries).map(countryCode => ({
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ReactCountryFlag
            countryCode={countryCode}
            style={{ width: '1.5em', height: '1.5em', marginRight: '0.5em' }}
            aria-label={countryCode}
          />
          {` + ${countries[countryCode].phone}`}
        </div>
      ),
      value: countries[countryCode].phone
    }));
    setSelectedCountryCode(options);

    const currentYear = new Date().getFullYear();
    let yearArray = [];
    for (let i = 1800; i <= currentYear; i++) {
      yearArray.push(i);
    }
    setYear(yearArray);

    GetAllCompanies().then(data => {
      setCompanies(data.data.response.companies);
    }).catch(error => {
      console.log("error ====> ", error);
    });
  }, []);


  return (
    <Layout>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          initialValues={
            initialValues
          }
          validate={values => {
            const error = {};
            if (values.logo === undefined || values.logo.type || !values.logo) {
              if (values.logo === undefined || !values.logo) {
                error.logo = 'Image is required';
                $("#errortext").text("Image is required");
              } else if (!values?.logo?.name?.match(/\.(jpg|jpeg|png|webp|avif|gif)$/)) {
                error.logo = 'Invalid Image Format';
                $("#errortext").text("Invalid Image Format");
              } else if (values.logo.size > MAX_FILE_SIZE) {
                error.logo = 'Image size exceeds the limit of 5MB';
                $("#errortext").text("Image size exceeds the limit of 5MB");
              } else {
                $("#errortext").text("");
              }
            }
            if (!values.name.trim()) {
              error.name = "Name is required";
            } else if (values.name.trim().length < 3) {
              error.name = "Name must be at least 3 characters";
            } else if (values.name.trim().length > 20) {
              error.name = "Name cannot exceed 20 characters";
            }
            if (!values.country_code || (Array.isArray(values.country_code) && values.country_code.length === 0)) error.country_code = "Country code is required";
            // console.log("counter code error",values.country_code);

            if (!values.official_email) {
              error.official_email = "Email is required"
            } else if (!/^[a-zA-Z0-9._'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(values.official_email)) {
              error.official_email = 'Invalid email address';
            }
            // if (!values.tax_type) {
            //   error.tax_type = "Tax type is required"
            // }

            if (!values.official_phone_number.trim()) {
              error.official_phone_number = "Phone number is required"
            } else if (values.official_phone_number.length !== getMobileLength(values.country_code)) {
              error.official_phone_number = `Please enter a valid ${getMobileLength(values.country_code)}-digits phone number`;
            }
            if (!values.official_address.trim()) {
              error.official_address = "Official address is required";
            } else if (values.official_address.trim().length > 250) {
              error.official_address = "Official address cannot exceed 250 characters";
            }
            if (!values.short_description.trim()) {
              error.short_description = "Short description is required";
            } else if (values.short_description.trim().length < 20) {
              error.short_description = "Short description must be at least 20 characters";
            } else if (values.short_description.trim().length > 500) {
              error.short_description = "Short description cannot exceed 500 characters";
            }
            if (!values.long_description.trim()) {
              error.long_description = "Long description is required";
            } else if (values.long_description.trim().length < 20) {
              error.long_description = "Long description must be at least 20 characters";
            } else if (values.long_description.trim().length > 500) {
              error.long_description = "Long description cannot exceed 500 characters";
            }
            if (!values.subscription_access) {
              error.subscription_access = "Subscription access is required";
            }


            return error;
          }}
          
          onSubmit={async (values, { setSubmitting }) => {
            setLoader(true);
            try {
              let formData = new FormData();
              formData.append('name', values.name.trim());
              formData.append('short_description', values.short_description.trim());
              formData.append('established_year', values.established_year);
              formData.append('official_address', values.official_address.trim());
              formData.append('official_email', values.official_email);
              formData.append('long_description', values.long_description.trim());
              formData.append('official_phone_number', values.official_phone_number);
              formData.append('licence_number', values.licence_number.trim());
              // formData.append('tax_type', values.tax_type);
              formData.append('subscription_access', values.subscription_access);
              formData.append('country_code', values.country_code);
              formData.append('is_grouped', values.is_grouped);
              const response = await CreateCompany(formData);
              if (response.data.status === 1 || response.data.status === "1") {
                const createdCompany = response?.data?.response || {};
                const newCompanyId = createdCompany.id;
                const companyRegisterId = createdCompany.company_register_id;

                if (values.logo instanceof File && newCompanyId && companyRegisterId) {
                  try {
                    const signedUrlResponse = await GetGCPSignedUploadUrl({
                      original_name: values.logo.name,
                      file_prefix: FILE_SLUGS.COMPANY_LOGO,
                      mime_type: values.logo.type,
                      folder: `company-id-${companyRegisterId}/${UPLOAD_DIRS.COMPANY_LOGO}`,
                    });
                    const { signedUrl, filename } = signedUrlResponse?.data?.response;
                    await fetch(signedUrl, { method: 'PUT', headers: { 'Content-Type': values.logo.type }, body: values.logo });
                    await UpdateCompanyLogo({ id: newCompanyId, logo: filename });
                  } catch (uploadError) {
                    console.log("Media upload error ====> ", uploadError);
                    Swal.fire({
                      customClass: 'swal-wide',
                      icon: 'error',
                      title: 'Company created but logo upload failed',
                      showConfirmButton: false,
                      timer: 3000,
                      toast: true,
                      position: 'top-right',
                    });
                  }
                }

                setSubmitting(false);
                setSubmitted(false);
                setLoader(false);
                Swal.fire({
                  customClass: 'swal-wide',
                  icon: 'success',
                  title: 'Company created successfully',
                  showConfirmButton: false,
                  timer: 1500,
                  toast: true,
                  position: 'top-right',
                });
                setTimeout(() => {
                  setLoader(false);
                  navigate(`/admin/company/list/${1}`);
                }, 1000);
              } else {
                setSubmitting(false);
                setSubmitted(false);
                setLoader(false);
                Swal.fire({
                  customClass: 'swal-wide',
                  icon: 'error',
                  title: response.data.message,
                  showConfirmButton: false,
                  timer: 5000,
                  toast: true,
                  position: 'top-right',
                });
                setSubmitted(false);
                setLoader(false);
              }
            } catch (error) {
              setLoader(false);
              setSubmitting(false);
              console.log("error ====> ", error);
              Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: 'Something went wrong. Please try again.',
                showConfirmButton: false,
                timer: 3000,
                toast: true,
                position: 'top-right',
              });
            }
          }}

        >{({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched
        }) => (
          <>

            <form onSubmit={handleSubmit}>
              {console.log("formik values -->", values)}
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">Add Company</h6>
                      </div>
                      <div className="row row-sm">
                        <div className='col-lg-6 text-center form-group'>
                          <label htmlFor='logo' className='text-left d-flex'>Logo<span className="requirestar">*</span> </label>
                          <input className='form-control imgInput' id="logo" name="logo" accept="image/*" type="file"
                            onChange={(event) => {
                              setFieldValue("logo", event.currentTarget.files[0] || "");
                              { event.currentTarget.files.length == 1 ? (setPreviewImage(URL.createObjectURL(event.currentTarget.files[0]))) : (setPreviewImage("")) }
                            }}
                          />
                          <span className='text-danger d-flex text-left'>
                            {errors.logo && touched.logo && errors.logo}
                          </span>
                          <div className='d-flex justify-content-start mt-3'>
                            <div className={previewImage ? "" : "d-none"}>
                              <img src={previewImage} style={{ height: "100px" }} />
                            </div>
                          </div>
                        </div>
                        <div className='col-lg-12 text-center form-group'>
                          <label htmlFor='name' className='text-left d-flex'>Name <span className="requirestar">*</span></label>
                          <input name='name' id="name" type='text' placeholder='Enter name' onChange={handleChange} onBlur={handleBlur} value={values.name} className='form-control' />
                          <span className='text-danger d-flex text-left'>{errors.name && touched.name && errors.name}</span>
                        </div>
                        <div className='col-lg-12 text-center form-group required'>
                          <label htmlFor='short_description' className='text-left d-flex'>Short description  <span className="requirestar">*</span> </label>
                          <textarea name='short_description' placeholder='Enter short description' id="short_description" rows="2" type='text' onChange={handleChange} onBlur={handleBlur} value={values.short_description} className='form-control' />
                          <span className='text-danger d-flex text-left'>{errors.short_description && touched.short_description && errors.short_description}</span>
                        </div>
                        <div className='col-lg-12  text-center form-group'>
                          <label htmlFor='subject' className='text-left d-flex'>Long description <span className="requirestar">*</span></label>

                          {/* <CKEditor
                            editor={ClassicEditor}
                            // config={ editorConfiguration }
                            data={values.long_description}
                            config={{
                              placeholder: 'Enter long description',
                            }}
                            onReady={editor => {
                              console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                              setFieldValue("long_description", editor.getData());
                            }}
                            onBlur={(event, editor) => {
                              console.log('Blur.', editor);
                            }}
                            onFocus={(event, editor) => {
                              console.log('Focus.', editor);
                            }}
                          /> */}

                          <CustomCkeditor
                            fieldname={"long_description"}
                            setFieldValue={setFieldValue}
                            value={values.long_description}
                            setFieldTouched={setFieldTouched}
                          />

                          <span className='text-danger d-flex text-left'>{errors.long_description && touched.long_description && errors.long_description}</span>
                        </div>
                        <div className='col-lg-12 text-center form-group'>
                          <label htmlFor='established_year' className='text-left d-flex'>Established year <span className="requirestar">*</span></label>
                          <div className='select-down-arrow'>
                            <select id="established_year" className='form-control' name='established_year' onChange={handleChange} onBlur={handleBlur} value={values.established_year}>
                              <option value="">Select year</option>
                              {year.length ? year.map((row, i) => (
                                <option value={row}>{row}</option>
                              )) : ''}
                            </select>
                          </div>
                          <span className='text-danger d-flex text-left'>{errors.established_year && touched.established_year && errors.established_year}</span>
                        </div>
                        <div className='col-lg-12 text-center form-group'>
                          <label htmlFor='official_address' className='text-left d-flex'>Official address <span className="requirestar">*</span></label>
                          <input name='official_address' id="official_address" placeholder='Enter official address' type='text' onChange={handleChange} onBlur={handleBlur} value={values.official_address} className='form-control' />
                          <span className='text-danger d-flex text-left'>{errors.official_address && touched.official_address && errors.official_address}</span>
                        </div>
                        <div className='col-lg-12 text-center form-group'>
                          <label htmlFor='official_email' className='text-left d-flex'>Official email <span className="requirestar">*</span></label>
                          <input disabled={state && state.official_email} name='official_email' id="official_email" placeholder='Enter official email' type='email' onChange={handleChange} onBlur={handleBlur} value={values.official_email} className='form-control' />
                          <span className='text-danger d-flex text-left'>{errors.official_email && touched.official_email && errors.official_email}</span>
                        </div>
                        <div className='col-lg-12 text-center form-group'>
                          <label htmlFor='official_phone_number' className='text-left d-flex'>
                            Official phone number <span className="requirestar">*</span>
                          </label>
                          <div className='d-flex phonenumber-input'>
                            <SelectPicker style={{ border: 'none', paddingLeft: '0', paddingRight: '0' }}
                              data={selectedCountryCode}
                              name='country_code'
                              className='form-control'
                              id='country_code'
                              onChange={value => setFieldValue('country_code', value)}
                              onBlur={handleBlur}
                              value={values.country_code}
                              placeholder="Select code"
                            />
                            <input
                              name='official_phone_number'
                              id="official_phone_number"
                              type='text'
                              placeholder='Enter phone number'
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.official_phone_number}
                              className='form-control form-control-number '
                            />
                          </div>
                          <span className='text-danger d-flex text-left'>
                            {errors.country_code && touched.country_code && errors.country_code}
                          </span>
                          <span className='text-danger d-flex text-left'>
                            {errors.official_phone_number && touched.official_phone_number && errors.official_phone_number}
                          </span>
                        </div>
                        <div className='col-lg-12 text-center form-group'>
                          <label htmlFor='licence_number' className='text-left d-flex'>Licence number</label>
                          <input name='licence_number' id="licence_number" placeholder='Enter licence number' type='text' onChange={handleChange} onBlur={handleBlur} value={values.licence_number} className='form-control' />

                        </div>
                        {/* <div className='col-lg-12 text-center form-group'>
                          <label htmlFor='tax_type' className='text-left d-flex'>Tax Type<span className="requirestar">*</span></label>
                          <div className='select-down-arrow'>
                            <select id="tax_type" className='form-control' name='tax_type' onChange={handleChange} onBlur={handleBlur} value={values.tax_type}>
                              <option value="">Select Tax Type</option>
                              <option value='inclusive'>Inclusive</option>
                              <option value='exclusive'>Exclusive</option>
                            </select>
                          </div>
                          <span className='text-danger d-flex text-left'>{errors.tax_type && touched.tax_type && errors.tax_type}</span>
                        </div> */}
                        <div className='col-lg-12 text-center form-group'>
                          <label htmlFor='subscription_access' className='text-left d-flex'>Subscription access <span className="requirestar">*</span></label>
                          <div className='select-down-arrow'>
                            <select id="subscription_access" className='form-control' name='subscription_access' onChange={handleChange} onBlur={handleBlur} value={values.subscription_access}>
                              <option value="">Select subscription access</option>
                              <option value={true}>Yes</option>
                              <option value={false}>No</option>
                            </select>
                          </div>
                          <span className='text-danger d-flex text-left'>{errors.subscription_access && touched.subscription_access && errors.subscription_access}</span>
                        </div>
                        <div className='col-lg-12 text-center form-group'>
                          <label htmlFor='is_grouped' className='text-left d-flex'>Create company in a group ? </label>
                          <div className='select-down-arrow'>
                            <select id="is_grouped" className='form-control' name='is_grouped' onChange={handleChange} onBlur={handleBlur}>
                              <option value="">Select company</option>
                              {
                                companies.map((company) => {
                                  return <option value={company.id}>{company.name}</option>
                                })
                              }
                            </select>
                          </div>
                          <span className='text-danger d-flex text-left'>{errors.is_grouped && touched.is_grouped && errors.is_grouped}</span>
                        </div>
                        <div className="">

                          <button className={"btn btn-info mr-2  " + (loader === true ? " disabled" : "")} type="submit">
                            <i className="ace-icon fa fa-check bigger-110 mx-1"> </i>
                            Submit
                            {loader === true ?
                              <div className="spinner-border text-white " role="status">
                                <span className="sr-only">Loading...</span>
                              </div>
                              : ""}
                          </button>

                          <button className="btn ripple btn-secondary" type='button' disabled={submitted ? true : null} onClick={() => navigate(-1)}>
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </form>
          </>
        )}
        </Formik>
      ) : (
        <></>
      )}
      <ToastContainer
        position="top-right"
        hideProgressBar={false}
        autoClose={true | 1000}
        newestOnTop={true}
        closeOnClick={false}
        draggable={false}
        rtl={false}
      />
    </Layout>
  );
}

export default CompanyForm